import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Layout from "Layout";
import AcademyCredentialsModal from "./AcademyCredentialsModal";
import "./academy.scss";
import { mixPostV1, mixPostV2 } from "services/mixin";
import { toast } from "react-toastify";
import { API_URL } from "env";
import AccountDetail from "components/Account/trader_account_info";
import './styles.scss'
import { checkAndUpdateAddressToBackend } from "wagmi_config/function/13w";
import { useAccount, usePublicClient } from "wagmi";

interface UserData {
    accountId: string;
    name: string;
    platform: string;
    broker: string;
}

const PickAccount: React.FC = () => {
    const { t } = useTranslation();

    const publicClient = usePublicClient()
    const { address } = useAccount()
    const [user, setUser] = useState<any>(null);
    const [showModal, setShowModal] = useState(false);
    const [accounts, setAccounts] = useState<any>();
    const [newAccountModal, setNewAccountModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [countUpdate, setCountUpdate] = useState<number>(0)
    const [userId, setUserId] = useState<string>('')
    const [userAccount, setUserAccounts] = useState<UserData>();
    const [visible, setVisible] = useState<boolean>(true);
    const [showCredentialsModal, setShowCredentialsModal] = useState<boolean>(false);

    const handleShowModalCredentials = (value: boolean, accountId: string) => {
        setShowCredentialsModal(value);
        if (value) {
            getTradeAccountData().then((data) => {
                if (data && data.account_number === accountId) {
                    setUserAccounts(data);
                }
            });
        }
    }

    const handleSave = (data: any) => {
        console.log('Saved data:', data);
        setShowModal(false);
        onSaveNewAccount(
            data.accountId,
            data.nickName,
            data.platform,
            data.broker,
        );
    };

    const deleteAccount = async (id: number) => {
        const token = localStorage.getItem('token')
        const res = await fetch(API_URL + `/api/v1/be/trade_account/${id}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            method: "DELETE",
        })

        if (res.status) {
            toast.success('Deleted Successful', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            const count = countUpdate + 1
            setCountUpdate(count)
        } else {
            toast.error('There is an error', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    async function getTradeAccountData() {
        try {
            const response = await fetch(`${API_URL}/api/v1/be/13w-challenges/info`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            if (response.status === 200) {
                const data = await response.json();
                if (data.data.length === 0) {
                    await checkAndUpdateAddressToBackend(publicClient, userId, address as `0x${string}`);
                }
                if (data.data[0].account_number === null) {
                    setAccounts(null);
                    return null;
                }
                
                setAccounts(data.data[0] || null);
                return data.data[0];
            }
        } catch (error) {
            console.error("Error fetching trade account data:", error);
        }
    }


    async function onSaveNewAccount(
        accountId: string,
        nickname: string,
        platform: string,
        broker: string,
    ) {
        try {
            if (!accountId || !nickname || !platform || !broker) {
                toast.error('Please fill all fields', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return;
            }
            // if (isNaN(parseFloat(balanceSize)) || parseFloat(balanceSize) <= 0) {
            //   toast.error('Balance size must be a positive number', {
            //     position: "top-right",
            //     autoClose: 5000,
            //     hideProgressBar: false,
            //     closeOnClick: false,
            //     pauseOnHover: true,
            //     draggable: true,
            //     progress: undefined,
            //     theme: "light",
            //   });
            //   return;
            // }
            if (userAccount && userAccount.accountId === accountId) {
                const updateInfo = await fetch(API_URL + `/api/v1/be/trade_account/${userAccount?.accountId}?nickname=${nickname}&platform=${platform}&broker=${broker}`,
                    {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem('token')}`,
                        },
                    }
                )
                if (updateInfo.status) {
                    toast.success('Updated account information', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    const count = countUpdate + 1
                    setCountUpdate(count)
                    setNewAccountModal(false);
                } else {
                    toast.error('There is an error', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
                return;
            }
            else {
                const res2 = await mixPostV2(`/terminal-accounts`, {
                    login_id: accountId,
                    app_type: platform,
                    broker: broker,
                    nickname: nickname,
                })
                const res = await mixPostV1(`/api/v1/be/trade_account`, {
                    account_number: accountId,
                    nickname: nickname,
                    platform: platform,
                    broker: broker,
                    user_id: userId,
                    "13w": true,
                })
                if (!res.status || !res2.status) {
                    toast.error(`Error: ${res.detail[0].msg || res2.msg} `, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });

                    setNewAccountModal(false);
                    return;
                }
                if (res.status && res2.status) {
                    toast.success('Created a new account', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });

                    setNewAccountModal(false);
                    const count = countUpdate + 1
                    setCountUpdate(count)

                }
            }

        } catch (error) {
            console.error("Error creating new account:", error);
            toast.error('There is an error', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }

    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            await getTradeAccountData();
        };
        fetchData();
        const user = localStorage.getItem("user");
        if (user) {
            const userObject = JSON.parse(user);
            setUserId(String(userObject.id))
            setUser(userObject);
        }
        const timer = setTimeout(() => {
            setLoading(false);
        }, 3000);
    }, []);


    return (
        <Layout>
            <div className="academy-container min-h-[90vh] rounded-[6px] p-6 accounts-overview _tw">
                <div className="mb-6 flex justify-between items-center">
                    <div>
                        <h1 className="text-3xl font-bold mb-2 text-content-primary">{t('pickAccount_title')}</h1>
                        <p className="text-content-secondary">{t('pickAccount_desc')}</p>
                    </div>
                    {(!accounts && !loading) && (
                        <button
                            onClick={() => setShowModal(true)}
                            className="academy-add-button _button_rcmwj_3 _size-large_rcmwj_242 _type-primary_rcmwj_31 _kind-filled_rcmwj_31"
                        >
                            <span className="flex items-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                </svg>
                                {t('Addnewaccount')}
                            </span>
                        </button>
                    )}
                </div>

                {(loading == true) ? (
                    <div className="flex flex-col justify-center items-center min-h-[60vh]">
                        <svg className="animate-spin h-10 w-10 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                        </svg>
                        <p className="text-gray-500">{t('account_loading')}</p>
                    </div>
                ) :
                    ((accounts && loading == false) ? (
                        <AccountDetail
                            key={accounts.id}
                            idAccount={accounts.id}
                            accountId={accounts.account_number}
                            current_balance_formatted={accounts.trading_stats.current_balance_formatted}
                            current_equity_formatted={accounts.trading_stats.current_equity_formatted}
                            current_pnl_formatted={accounts.trading_stats.current_pnl_formatted}
                            todays_profit_formatted={accounts.trading_stats.todays_profit_formatted}
                            current_equity={accounts.trading_stats.current_equity}
                            current_balance={accounts.trading_stats.current_balance}
                            current_pnl={accounts.trading_stats.current_pnl}
                            todays_profit={accounts.trading_stats.todays_profit}
                            index={0}
                            visible={visible}
                            disableVisible={true}
                            setVisible={setVisible}
                            setIsShowModalCredentials={(value, accountId) =>
                                handleShowModalCredentials(value, accountId)
                            }
                            status={'active'}
                            accountType={accounts.accountType}
                            accountLevel={accounts.accountLevel}
                            created_at={accounts.created_at}
                            endDate={accounts.endDate}
                            loginCredentials={accounts.loginCredentials}
                            perfomance={accounts.perfomance}
                            platform={accounts.platform}
                            currency={accounts.currency}
                            user={
                                {
                                    userName: accounts.nickname,
                                    broker: accounts.broker,
                                    userId: accounts.user_id,
                                }
                            }
                            deleteAccount={deleteAccount}
                        />
                    ) : (
                        <div className="flex justify-center items-center min-h-[60vh]">
                            <div className="text-center flex flex-col items-center">
                                <div className="mb-6">
                                    <svg className="w-32 h-32 mx-auto text-content-tertiary opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                </div>
                                <h2 className="text-xl font-semibold mb-3 text-content-primary">{t('pickAccount_noAccount')}</h2>
                                <p className="text-content-secondary mb-6">{t('pickAccount_createAccount')}</p>
                                <button
                                    onClick={() => setShowModal(true)}
                                    className="academy-add-button _button_rcmwj_3 _size-large_rcmwj_242 _type-primary_rcmwj_31 _kind-filled_rcmwj_31"
                                >
                                    <span className="flex items-center gap-2">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                        </svg>
                                        {t('Addnewaccount')}
                                    </span>
                                </button>
                            </div>
                        </div>
                    )
                    )
                }

                {/* Modal */}
                {showModal && (
                    <AcademyCredentialsModal
                        onClose={() => setShowModal(false)}
                        onSave={handleSave}
                    />
                )}
            </div>
        </Layout>
    );
};

export default PickAccount;
